import { Users, Briefcase, Rocket } from "lucide-react";
import Reveal from "@/components/site/Reveal";
import { JOIN } from "@/constants/testIds";

const PROFILES = [
  {
    slug: "sales",
    Icon: Users,
    title: "Sales Professionals",
    body: "If you have a network of business owners and love consultative selling.",
  },
  {
    slug: "consultants",
    Icon: Briefcase,
    title: "Business Consultants",
    body: "Add high-value services to your existing client relationships.",
  },
  {
    slug: "entrepreneurs",
    Icon: Rocket,
    title: "Entrepreneurs",
    body: "Build a residual income stream that scales with your effort.",
  },
];

export default function WhoSection() {
  return (
    <section
      data-testid={JOIN.who}
      className="section-pad"
      style={{ background: "#ffffff" }}
    >
      <div className="container-wide">
        <Reveal className="max-w-2xl mb-14">
          <div className="eyebrow mb-5">Who thrives here</div>
          <h2 className="type-section-heading">
            Who thrives as a SmartEdge agent?
          </h2>
        </Reveal>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {PROFILES.map((p, i) => (
            <Reveal key={p.slug} delay={i * 0.12}>
              <article
                data-testid={JOIN.whoCard(p.slug)}
                className="se-card h-full"
                style={{ padding: 0 }}
              >
                <div className="se-card__body">
                  <span
                    className="flex items-center justify-center mb-5"
                    style={{
                      width: 48,
                      height: 48,
                      borderRadius: 8,
                      background: "rgba(108,92,231,0.1)",
                      color: "var(--color-purple)",
                    }}
                  >
                    <p.Icon size={24} strokeWidth={1.5} />
                  </span>
                  <h3 className="type-subheading mb-3" style={{ fontSize: 22 }}>
                    {p.title}
                  </h3>
                  <p className="type-body">{p.body}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
